<template>
    <AppLayoutBase>
        <template slot="drawer">
            <AppLayoutNavbarDrawer>
                <template slot="list">
                    <SettingsLayoutDrawer/>
                </template>
            </AppLayoutNavbarDrawer>
        </template>

        <template slot="main">
            <SettingsUsersContent/>
        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        name: "AdminUsers"
    }
</script>

<style scoped>

</style>